import React, { createContext, useState, useReducer, useMemo } from "react";
import { Loading } from "./base";
import { UserAccessableTabs, userAccessableTabs } from "../lib/api/user-tabs";

const defaultUserAccessableTabs = {
  "Dashboard/Executive Summary": [],
  "Dashboard/New": [],
  "Dashboard/Used": [],
  "Dashboard/Parts": [],
  "Dashboard/Service": [],
  "Dashboard/Body Shop": [],
  "Dashboard/Custom": [],
  "Reports/OEM Reports": [],
  "Reports/Other BM Tools": [],
  "Reports/Performance Analysis": [],
  "Reports/Standard Reports": [],
  "Submission/Deadlines": [],
  "Submission/Download Templates": [],
  "Submission/Submit Data": [],
  "Insights/Interpretation": [],
  "Insights/Data Preparation": [],
  "Insights/BM Process": [],
  "Insights/Industry Insights": [],
};

export type UserAccessableTabsContextState = {
  tabs: UserAccessableTabs;
  loading: Loading;
  hydrate();
};

export const UserAccessableTabsContext = createContext<UserAccessableTabsContextState>({
  tabs: defaultUserAccessableTabs,
  loading: { loading: false, loaded: false, error: null },
  hydrate: () => {},
});

export const UserAccessableTabsProvider = ({ children }) => {
  const [tabs, setUserAccessableTabs] = useState<UserAccessableTabs>(defaultUserAccessableTabs);
  const [loading, setLoading] = useState<Loading>({ loading: false, loaded: false, error: null });
  const value = useMemo(
    () => ({
      tabs,
      loading,
      hydrate: async () => {
        try {
          setLoading({
            loading: true,
            loaded: false,
            error: null,
          });
          const tabs = await userAccessableTabs();
          setUserAccessableTabs(tabs);
          setLoading({
            loading: false,
            loaded: true,
            error: null,
          });
        } catch (e) {
          setLoading({
            loading: false,
            loaded: false,
            error: e,
          });
        }
      },
      setUserAccessableTabs,
    }),
    [tabs, loading],
  );
  return <UserAccessableTabsContext.Provider value={value}>{children}</UserAccessableTabsContext.Provider>;
};
